import { FC } from "react";
import useModal from "../../../hooks/useModal";
import { VerticalStack } from "../../Stack";
import {
  DefaultButton,
  IStackStyles,
  Text,
  TooltipHost,
} from "@fluentui/react";
import { CreateProjectModal } from "../CreateProjectModal";
import { ProjectCard } from "../../Cards/ProjectCard";
import { useTranslation } from "react-i18next";
import { colorPallete } from "../../../assets/color";

const headerStyle = {
  fontSize: "18px",
  color: colorPallete.black1,
  fontWeight: 400,
  fontFamily: "Poppins",
};

const addIcon = {
  iconName: "CircleAdditionSolid",
  styles: {
    root: { color: colorPallete.btBlue, fontSize: "48px" },
  },
};

const buttonStyle = {
  backgroundColor: colorPallete.white,
  borderColor: colorPallete.white,
  margin: "1rem",
};

const verticalStackStyles: IStackStyles = {
  root: {
    height: "100%",
    backgroundColor: "",
  },
};
interface IProps {
  projectLimit: number;
  setProjectLimit: (limit: number) => void;
}
export const NewProject = (props: IProps) => {
  const { setProjectLimit, projectLimit } = props;

  const { isModalOpen, showModal, hideModal } = useModal();
  const { t } = useTranslation();

  return (
    <ProjectCard>
      <TooltipHost
        content={
          projectLimit === 0 ? "You have reached your project creation limit. To create a new project, please contact us at Info@dexteritylegal.com.": ""
        }
        
      >
        <div className="ProjectCard">
          <div
            className="Card"
            onClick={projectLimit === 0 ? hideModal : showModal}
          >
            <VerticalStack
              verticalAlign="center"
              styles={verticalStackStyles}
              horizontalAlign="center"
            >
              <DefaultButton
                iconProps={addIcon}
                style={buttonStyle}
                title={String(t("click_to_create_new_project"))}
                disabled={projectLimit === 0}
              />
              <Text style={{ ...headerStyle, textAlign: "center" }}>
                {t("create_new_project")}
              </Text>
            </VerticalStack>
            <CreateProjectModal
              isModalOpen={isModalOpen}
              showModal={showModal}
              hideModal={hideModal}
              setProjectLimit={setProjectLimit}
            />
          </div>
        </div>
      </TooltipHost>
    </ProjectCard>
  );
};
